export const formatString = (str: string) => {
  return str.replace(/[^\u0020-\u007E\u00A0-\u00FF]/g, '')
}
